module.exports = ".edit-impersonate .edit-driver-type-select /deep/ .dropdown {\n  display: block;\n  margin-top: 10px;\n}\n.edit-impersonate .edit-impersonate-btn {\n  margin: 25px 2px 2px;\n}\n.edit-impersonate .roles {\n  padding: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/impersonate/impersonate.less
// module id = ./src/app/management/components/impersonate/impersonate.less
// module chunks = main